import React, { useState } from 'react';
import axios from 'axios';
import { Form, Input, Button, Typography, Row, Col, message } from 'antd';
import { LockOutlined, PhoneOutlined } from '@ant-design/icons';
import { BASE_URL, getAuthHeaders } from '../composant/ComposantAPP/Util';

import '../styles/Login.css';
import Logo from '../assets/ispatec_logo.png';

const { Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const token = btoa(values.telephone.trim() + ':' + values.password.trim());

        const response = await axios.get('http://localhost:8080/auth/login', {
        headers: {
          'Authorization': 'Basic ' + token,
          'Content-Type': 'application/json',
        },
      });
      const data = response.data

      if (!data.statut_compte) {
        message.error("Votre compte n'est pas encore activé. Veuillez contacter l'administration.");
        
        setLoading(false);
        return;
      }

      // Connexion autorisée
      localStorage.setItem('token', token);
      localStorage.setItem('employer', JSON.stringify(data));

      message.success('Connexion réussie !');
      window.location.href = '/dashboard';

    } catch (error) {
      if (error.response) {
        message.error(error.response.data.message || 'Erreur d\'authentification.');
      } else {
        message.error('Erreur réseau. Veuillez réessayer.');
      }
    } finally {
      setLoading(false);
    }
  };

  // 🔧 Ajoute cette fonction
  const onFinishFailed = (errorInfo) => {
    console.log('Échec de soumission du formulaire :', errorInfo);
  };

  return (
    <div className="login-container">
      <div className="overlay"></div>
      <Row justify="center" align="middle" className="login-row">
        <Col xs={22} sm={16} md={12} lg={8}>
          <div className="login-box">
            {/* Logo */}
            <div className="logo-container">
              <img src={Logo} alt="Logo Ispatec" className="logo-image" />
            </div>

            {/* Message d'accueil */}
            <div className="welcome-message">
              <Text style={{ fontSize: '2rem' }}>
                Bon retour 👋 !
              </Text>
              <br />
              <Text style={{ color: "#ff6600" }}>Nous sommes ravis de vous revoir ✨</Text>
            </div>

            {/* Formulaire de connexion */}
            <Form
              name="login"
              layout="vertical"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="telephone"
                label="Téléphone"
                rules={[{ required: true, message: 'Veuillez entrer votre téléphone' }]}
              >
                <Input prefix={<PhoneOutlined />} placeholder="Ex: +223 70 00 00 00" />
              </Form.Item>

              <Form.Item
                name="password"
                label="Mot de passe"
                rules={[{ required: true, message: 'Veuillez entrer votre mot de passe' }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="Votre mot de passe" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  className="login-btn"
                  loading={loading}
                >
                  Se connecter
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
